const React = require('react');
const Demo = require('../base-live-demo-component');
const componentCodeFront = require('./componentCodeFront');
const componentCodeBack = require('./componentCodeBack');
const View = require('./componentView');

const { useEffect } = React;
const componentProps = require('./componentProps');

const BricksComponent = ({ i18n, deviceType, lang, userData, platform, liveDemoId, isLoggedAccountATestUser, email, actualUrl, brand }) => {
  const customHook = ({ styleProperties, setFormData }) => {
    useEffect(() => {
      const customInputErrors = {
        styleProperties: false,
      };

      try {
        JSON.parse(styleProperties);
      } catch {
        customInputErrors.styleProperties = {
          hasError: true,
          message: 'Revisa el formato de la configuración',
        };
      }

      setFormData(prev => ({
        ...prev,
        customErrors: { ...customInputErrors },
        brand: { brand },
      }));
    }, [styleProperties]);
  };

  return (<Demo
    customHook={customHook}
    componentDemo={View}
    componentSnippetFront={componentCodeFront}
    componentSnippetBack={componentCodeBack}
    componentProps={componentProps.getProps(i18n, lang, brand)}
    deviceType={deviceType}
    i18n={i18n}
    lang={lang}
    email={email}
    actualUrl={actualUrl}
    userData={userData}
    platform={platform}
    liveDemoId={liveDemoId}
    customMessage={{
      shouldShow: !isLoggedAccountATestUser,
      content: <>{i18n.gettext(
        'Para una visualización completa del checkout en la demostración, utiliza una',
      )}
        &nbsp;
        <a
          href={`/developers/${lang}/docs/your-integrations/test/accounts`}
        >
          {i18n.gettext('cuenta de testeo')}
        </a>
        . &nbsp;
        {i18n.gettext(
          'El uso de una cuenta real puede comprometer la experiencia.',
        )}
      </>,
    }}
  />);
};
module.exports = BricksComponent;
